import React from 'react';
import { BiAddToQueue } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'underscore';

import { Manifest } from 'services/action';

import { Page } from 'ui/components';

import ManifestCard from './component/manifest.card';
import ManifestDetail from './component/manifest.detail';

const ManifestMonitoring = () => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Get']
  );

  const [data, setData] = React.useState(null);
  const [detail, setDetail] = React.useState(null);
  const [empty, setEmpty] = React.useState(false);
  const [privilege, setPrivilege] = React.useState(null);

  const $onLoad = async (e) => {
    const req = await Dispatch(
      Manifest.$get({ status: 'started', order_by: '-created_at', limit: 1000 })
    );

    if (req?.message === 'success' && req?.data?.length) {
      setData(req?.data);
      $onLoadDetail(req?.data[0]?.id);
    } else {
      setEmpty(true);
    }
  };

  const $onLoadDetail = async (e) => {
    const req = await Dispatch(Manifest.$show(e));

    if (req?.message === 'success') {
      setDetail(req?.data);
    }
  };

  const $getPrivilege = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.manifest',
    });
    setPrivilege(x);
  };

  React.useEffect(() => {
    $onLoad();
  }, []);

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  if (empty) {
    return (
      <Page className="">
        <Page.Header
          pretitle="monitoring"
          title="Manifest Pengiriman"
          isLoading={StateLoading}
          action={
            !Session?.privileges || privilege?.action === 'manage'
              ? { url: '/manifest/create', text: 'Buat Manifest Baru' }
              : null
          }
        />
        <Page.Body className="position-relative manifest-monitoring border-top">
          <Page.Empty title="Belum ada manifest yang harus dimonitor" />
        </Page.Body>
      </Page>
    );
  }

  return (
    <Page className="">
      {!data && (
        <Page.Header
          pretitle="monitoring"
          title="Manifest Pengiriman"
          isLoading={StateLoading}
          action={
            !Session?.privileges || privilege?.action === 'manage'
              ? { url: '/manifest/create', text: 'Buat Manifest Baru' }
              : null
          }
        />
      )}
      <Page.Body className="position-relative manifest-monitoring border-top">
        <div className="row">
          <div className="col-md-3 sidebar">
            {data && (
              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center px-3 py-2">
                  <div>
                    <div className="page-pretitle">monitoring</div>
                    <h2 className="page-title">Manifest Pengiriman</h2>
                  </div>
                  {(!Session?.privileges || privilege?.action === 'manage') && (
                    <div>
                      <Link
                        to={'/manifest/create'}
                        className="btn btn-primary py-1"
                      >
                        <BiAddToQueue color="white" size="14" />
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            )}
            {data?.map((d, i) => (
              <ManifestCard
                data={d}
                keys={i}
                key={i}
                active={detail?.id === d?.id}
                onClick={$onLoadDetail}
                privilege={
                  !Session?.privileges || privilege?.action === 'manage'
                }
              />
            ))}
          </div>
          <div className="col-md-9 ps-0">
            <ManifestDetail data={detail} />
          </div>
        </div>
      </Page.Body>
    </Page>
  );
};

export default ManifestMonitoring;
